import React from "react";
import { useSelector } from "react-redux";
import AutoTranslate from "../../../Components/AutoTranslate";

const StepProgress = ({ currentStep = 0, totalSteps = 0, stepLabels = [] }) => {
  const language = useSelector((state) => state.localStorage.language);
  return (
    <div className='step-progress mb-4'>
      <div className='progress-container'>
        <div className='progress-bar' style={{ width: `${(currentStep / (totalSteps - 1)) * 100}%` }}></div>
      </div>
      <div className='step-labels'>
        {stepLabels.map((label, index) => (
          <div key={index} className={`step-label ${index <= currentStep ? "active" : ""}`}>
            <AutoTranslate targetLanguage={language.lang}>{label}</AutoTranslate>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepProgress;
